export enum VotingDisplayMode {
  SUBMISSION,
  RESULTS,
  INSUFFICIENT_VOTES,
}

export enum VotingPhase {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum LocalVotingStatus {
  OPEN_ELIGIBLE = 'open_eligible',
  REVIEW = 'review',
  RESULTS = 'results',
  CLOSED = 'closed',
  VOTE_FAILED = 'vote_failed'
}

export enum VotingType {
  None = 'none',
  CTLeagueRound = 'ct_league_round',
  PopularTeamState = 'popular_team_state',
  PopularTeamCountry = 'popular_team_country'
}

export enum ItemType {
  PLAYER = 'player',
  TEAM = 'team',
  UNKNOWN = 'unknown'
}
